import type { ComponentType } from 'react'
import { z } from 'zod'
import { IconName } from 'lucide-react/dynamic'

export enum BuilderNode {
  START = 'start',
  END = 'end',
  TEXT_MESSAGE = 'text-message',
  CONDITIONAL_PATH = 'conditional-path',
  MENU = 'menu',
  ACTION = 'action',
  RANDOMIZER = 'randomizer',
  FLOW_CONNECTION = 'flow-connection',
  INTEGRATION = 'integration',
}

export const HeaderGradientColors = {
  purple: 'bg-purple-700/40',
  red: 'bg-red-700/40',
  blue: 'bg-blue-700/40',
  green: 'bg-green-700/40',
  yellow: 'bg-yellow-700/40',
  pink: 'bg-pink-700/40',
  orange: 'bg-orange-700/40',
  teal: 'bg-teal-700/40',
  lime: 'bg-lime-700/40',
  indigo: 'bg-indigo-700/40',
  fuchsia: 'bg-fuchsia-700/40',
  emerald: 'bg-emerald-700/40',
  cyan: 'bg-cyan-700/40',
  rose: 'bg-rose-700/40',
  sky: 'bg-sky-700/40',
  gray: 'bg-gray-700/40',
  slate: 'bg-slate-700/40',
}

export type BuilderNodeType = `${BuilderNode}`

export interface RegisterNodeMetadata<T = Record<string, unknown>> {
  type: BuilderNodeType
  node: ComponentType<any>
  detail: {
    icon: IconName
    title: string
    description: string
    gradientColor?: keyof typeof HeaderGradientColors
  }
  connection: {
    inputs: number
    outputs: number
  }
  available?: boolean
  defaultData?: T
  propertyPanel?: ComponentType<any>
  validationSchema?: z.ZodSchema<T>
}

export interface BaseNodeData extends Record<string, unknown> {
  deletable?: boolean
}
